// HORO-10509: reuses the exact same toast pattern as LiveReadingsToast (the
// "You have joined the waitlist!" confirmation) rather than introducing a
// separate notification style — see src/components/common/Toast.
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { clearAuthMessage, getAuthMessage } from '../../../store/slices/authSlice';
import Toast from '../../common/Toast';

// Maps authSlice's `authMessage` state to its display copy — add a case
// here for any future auth-flow success message that should surface as a
// toast.
const MESSAGE_KEYS = {
    passwordResetSuccess: 'modal.passwordResetSuccessToast',
    // HORO-10509 (Figma 4510:29992, "Sign in confirmation"): shown after an
    // existing user signs in with email/password — not on signup (a brand
    // new account isn't "back") and not the OAuth path (untouched by this
    // ticket).
    signInSuccess: 'modal.signInSuccessToast',
    // HORO-10509 (Figma 4564:52812 desktop / 4510:29794 mobile): shown
    // after a fresh signup completes email verification.
    accountCreated: 'modal.accountCreatedToast'
};

const AuthToast = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const authMessage = useSelector(getAuthMessage);
    const messageKey = authMessage && MESSAGE_KEYS[authMessage];

    return (
        <Toast
            show={Boolean(messageKey)}
            message={messageKey ? t(messageKey) : ''}
            dismissLabel={t('liveReadings.toastDismiss')}
            onDismiss={() => dispatch(clearAuthMessage())}
            fullWidthProgress
        />
    );
};

export default AuthToast;
